/* eslint-disable no-unused-vars */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import {
  AppBar,
  IconButton,
  Toolbar,
    Menu,
    MenuItem,
    Button,
  Hidden,
  SvgIcon,
  Box
} from '@material-ui/core';
import {KeyboardArrowDown, Menu as MenuIcon} from '@material-ui/icons';
import styles from './TopBar.module.scss';
import { Logo } from 'components';
import Account from './Account';
import {useTranslation} from "react-i18next";
import SecureLS from "secure-ls";


var localStorage = new SecureLS({ encodingType: 'aes' });

interface TopBarProps {
  onMobileNavOpen: any;
  className?: string;
}

const TopBar = (props: TopBarProps) => {
  const { onMobileNavOpen, className, ...rest } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { i18n } = useTranslation();
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    i18n.changeLanguage(localStorage.get('language') || 'fr');
  }, [i18n]);

  const handleClose = (lng: string | undefined) => {
    if (!!lng) {
      i18n.changeLanguage(lng.toLowerCase());
      localStorage.set('language', lng.toLowerCase());
    }
    setAnchorEl(null);
  };

  return (
    <AppBar className={clsx(styles.root, className)} elevation={0} {...rest}>
      <Toolbar className={styles.toolbar}>
        <Hidden lgUp>
          <IconButton
            className={styles.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <RouterLink to="/">
            <Logo className={styles.logo} />
          </RouterLink>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Button
            endIcon={
              <img
                  style={{ height: 28, width: 28 }}
                  alt="Ln"
                  src={`/images/${i18n.language}.svg`}
              />
            }
            style={{ color: '#1b70b9', fontSize: 18 }}
            onClick={handleClick}
        />
        <Box ml={2}>
          <Account />
        </Box>
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => handleClose(undefined)}>
          {[
            { value: 'fr', title: 'Français' },
            { value: 'en', title: 'English' }
          ].map((i) => (
              <MenuItem onClick={() => handleClose(i.value)} key={i.value}>
                <img
                    style={{ height: 20, width: 20, marginRight: 10 }}
                    alt="Logo"
                    src={`/images/${i.value}.svg`}
                />
                {i.title}
              </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
